module.exports = __webpack_public_path__ + "img/162100.accc245e.jpg";